// extracted by mini-css-extract-plugin
export default {"title_wrapper":"section-title_title_wrapper__spVAZ","title":"section-title_title__O6IsQ"};